// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6387b27","455":"f9efc953","946":"a5f4d961"}[chunkId] + ".chunk.js";
};